import React, { PureComponent } from 'react';

import {
  Wrapper,
  Title,
  Text,
  FormulaContainer,
  FormulaName,
  FormulaValue
} from '../components/ui';

class PeerScore extends PureComponent {
  render() {
    return (
      <Wrapper>
        <Title>PEER SCORE</Title>
        <Text>The peer score is based on how well a student collaborates with their teammates in relation to the overall team.</Text>
        <br />
        <Text><strong>Note:</strong> peer score formula cannot be modified.</Text>
        <FormulaContainer maxWidth={510}>
          <FormulaName>Peer Score</FormulaName>
          <FormulaValue fontSize="28px">=</FormulaValue>
          <FormulaValue>
            Student’s
            <br />
            Average Peer Rating
            <span className='divider' />
            Team’s
            <br />
            Average Peer Rating
          </FormulaValue>
        </FormulaContainer>
      </Wrapper>
    );
  }

}

export default PeerScore;



// WEBPACK FOOTER //
// ./src/instructor/components/grading/pages/peer-score.js